import { computed, type MaybeRef, unref } from 'vue'
import type { Article } from '~/types/models'

export const useArticle = (article: MaybeRef<Article.Model>) => {
  const id = computed<Article.Model['id']>(() => unref(article).id)
  const title = computed<Article.Model['title']>(() => unref(article).title)
  const metaTitle = computed<Article.Model['metaTitle']>(() => unref(article).metaTitle)
  const metaDescription = computed<Article.Model['metaDescription']>(() => unref(article).metaDescription)
  const shortDescription = computed<Article.Model['shortDescription']>(() => unref(article).shortDescription)
  const contentBlocks = computed<Article.Model['contentBlocks']>(() => unref(article)?.contentBlocks || [])

  return {
    id,
    contentBlocks,
    title,
    metaTitle,
    metaDescription,
    shortDescription,
  }
}
